<ng-container screenAnalytics="mission-lotam-view">
    <div class="modal-header no-icon">
        <h3 class="modal-title">Mission LOTAM</h3>
        <enhanced-help-switch></enhanced-help-switch>
        <button
            type="button"
            aria-label="Close"
            class="close"
            (click)="onCancel()"
        >
            <span aria-hidden="true">&times;</span>
        </button>
    </div>
    <div
        class="modal-body"
    >
            <lotam-details
                class="modal-body-content"
                [lotam]="lotam"
                [organisation]="organisation"
            >
            </lotam-details>
    </div>

    <div class="modal-footer">
        <p
            *ngIf="!this.isReadOnly && !isAcknowledgedInMission"
            class="text-danger"
            style="display: inline-block"
        >
            You have not acknowledged this LOTAM
        </p>
        <button
            *ngIf="!this.isReadOnly"
            type="button"
            class="btn btn-primary relative"
            [disabled]="isAcknowledgedInMission || working"
            (click)="onAcknowledgeForMission()"
        >
            {{ isAcknowledgedInMission ? 'Acknowledged' : 'Acknowledge' }}
            <span
                class="overlay"
                [tooltip]="
                    isAcknowledgedInMission
                        ? 'You have already acknowledged this LOTAM'
                        : 'Acknowledge this LOTAM'
                "
                placement="top"
            ></span>
        </button>
    </div>
</ng-container>
